import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CreateService {

  apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  listAllDrives(email: any): Observable<any> {
    return this.http.get(this.apiUrl + 'api/v1/drives?userEmail=' + email);
  }

  getDriveFiles(email: any, id: any) {
    return this.http.get(this.apiUrl + 'api/v1/drive/files?userEmail=' + email + '&parentId=' + id);
  }

  createFile(createFileObj: any): Observable<any> {
    return this.http.post(this.apiUrl + 'api/v1/createFile', createFileObj, { responseType: 'text' as 'json' });
  }

  uploadFile(destFolderId: any, userEmail: any, file: any): Observable<any> {
    const formData = new FormData();
    for (var i = 0; i < file.length; i++) {
      formData.append("file", file[i]);
    }
    return this.http.post(this.apiUrl + 'api/v1/uploadFiles?destFolderId=' + destFolderId + '&userEmail=' + userEmail, formData, { responseType: 'text' as 'json' });
  }

  uploadFolder(destFolderId: any, userEmail: any, folderName: any, folder: any): Observable<any> {
    const formData = new FormData();
    for (var i = 0; i < folder.length; i++) {
      formData.append("file", folder[i]);
    }
    return this.http.post(this.apiUrl + 'api/v1/uploadFolder?destFolderId=' + destFolderId + '&folderName=' + folderName + '&userEmail=' + userEmail, formData, { responseType: 'text' as 'json' });
  }

  getAuditLogs(email: any) {
    return this.http.get(this.apiUrl + 'api/v1/autilog?userEmail=' + email);
  }

  private parentId: BehaviorSubject<any> = new BehaviorSubject('');
  getParentId(): Observable<any> {
    return this.parentId.asObservable();
  }

  setParentId(parentId: any) {
    this.parentId.next(parentId);
  }

  private selectedDestination: BehaviorSubject<any> = new BehaviorSubject('');
  getSelectedDestination(): Observable<any> {
    return this.selectedDestination.asObservable();
  }

  setSelectedDestination(selectedDestination: any) {
    this.selectedDestination.next(selectedDestination);
  }

  getContentBySearch(emailids: any, driveid: any, userEmail: any) {
    return this.http.get(this.apiUrl + 'api/v1/addUser?emailIds=' + emailids + '&driveId=' + driveid + '&userEmail=' + userEmail, { responseType: 'text' as 'json' });
  }

  downloadUserAccessTemplateFromServer() {
    let dwldLink = document.createElement("a");
    dwldLink.setAttribute("target", "_blank");
    dwldLink.setAttribute("href", this.apiUrl + 'api/v1/downloadCsv');
    dwldLink.click();
  }

  uploadUserAccessTemplateFromServer(file: any) {
    const formData = new FormData();
    for (var i = 0; i < file.length; i++) {
      formData.append("file", file[i]);
    }
    return this.http.post(this.apiUrl + 'api/v1/uploadCsv', formData, { responseType: 'text' as 'json' });
  }

  checkUserAccessForUploadTemplate(userEmail: any) {
    return this.http.get(this.apiUrl + 'api/v1/bulkUploadVisibility?userEmail=' + userEmail);
  }

  fetchUser(driveId?: string, userEmail?: string ){
    //if(driveId != '' )
    let params = new HttpParams();
    if(driveId && userEmail){
     params = params.set('driveId', driveId);
     params =params.set('email', userEmail);
    }
    else if(driveId) {
      params = params.set('driveId', driveId);
    }
    else if(userEmail){
      params = params.set('email', userEmail);
    }
    return this.http.get(this.apiUrl + 'api/v1/fetchUser',{ params });
  }

  private isViewEdit: BehaviorSubject<any> = new BehaviorSubject(false);
  getIsViewEdit(): Observable<any> {
    return this.isViewEdit.asObservable();
  }
  
  setIsViewEdit(isViewEdit: any) {
    this.isViewEdit.next(isViewEdit);
  }

  private viewEditObj: BehaviorSubject<any> = new BehaviorSubject({});
  getViewEditObj(): Observable<any> {
    return this.viewEditObj.asObservable();
  }

  setViewEditObj(viewEditObj: any) {
    this.viewEditObj.next(viewEditObj);
  }

  saveUser(userData: any){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    }) 
    return this.http.post(this.apiUrl + 'api/v1/saveUser', userData, { headers });
  }

  updateUser(userData: any){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    }) 
    return this.http.post(this.apiUrl + 'api/v1/updateUser', userData, { headers });
  }

  deleteUser(row: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    }) 
    const options ={
      headers: headers,
      body: row, 
      responseType: 'text' as 'text'
    }
    return this.http.delete(this.apiUrl + 'api/v1/deleteUser', options);
  }

  isGroupMemberExist(membersEmail:string){
    let params = new HttpParams();
    params = params.set('membersEmail', membersEmail);
    return this.http.get(this.apiUrl + 'api/v1/isGroupMemberExist',{ params });
  }
}
